















import { Component, Vue } from 'vue-property-decorator'

// enum Color {a, b, c}
// let F :Color

@Component({
  components: {
  },
})
export default class Loading extends Vue {
    private cc: any = ''
    private cc2: any = ''
    private loadingDesc: string[] = ['小怪兽正在整理自己的头套', '小幽灵还在整理吵闹名单', '小恶魔正在想要对着谁捣乱']
    private nowLoadingDesc: string = '小怪兽正在整理自己的头套'
    private percent: number = 0
    private mounted () {
        // localStorage.removeItem('name')
        for (let i = 1; i < 18; i++) {
            const img = new Image()
            img.src = require(`../assets/GHOSTS/bg_ghost_${i.toString().padStart(2, '0')}@3x.png`)
            img.onload = () => {
                this.percent += 2
            }
            const img2 = new Image()
            img2.src = require(`../assets/GHOSTS/img_ghost_${i.toString().padStart(2, '0')}@3x.png`)
            img2.onload = () => {
                this.percent += 2
            }
        }
        for (let i = 1; i < 7; i++) {
            const img = new Image()
            img.src = require(`../assets/BED/img_quilt${i.toString().padStart(2, '0')}@3x.png`)
            img.onload = () => {
                this.percent += 2
            }
            const img2 = new Image()
            img2.src = require(`../assets/BED/img_polaroid_quilt${i.toString().padStart(2, '0')}@3x.png`)
            img2.onload = () => {
                this.percent += 2
            }
        }
        this.cc2 = setInterval(() => {
            if (this.percent >= 92) {
                this.percent = 100
                setTimeout(() => {
                    clearInterval(this.cc2)
                    this.$router.replace('./home')
                }, 400)
            }
        }, 1000)
        this.cc = setInterval(() => {
            this.nowLoadingDesc = this.loadingDesc[this.$wjh.randomNum(0, 2)]
        }, 2000)
    }
}
